var exports = {
  "Fm": "xe533113f--4d1555--factoid",
  "Kk": "xe533113f--4d1555--icon",
  "Qq": "xe533113f--4d1555--text",
};

module.exports = exports;
